import React from "react"

// ------------------------------------------------------------------------------
// LogoSVG Component - Horizontal agnos.ai brand logo
// Uses primary color by default, can be overridden with className
// ------------------------------------------------------------------------------
type LogoSVGProps = {
  className?: string
}

export const LogoSVG = ({ className }: LogoSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 121.97"
    className={`logo ${className || ""}`}
    preserveAspectRatio="xMidYMid meet"
  >
    <g fill="var(--color-primary)">
      {/* Full SVG paths below */}
      <path d="M35.41,94.89c-2.84,4.26-9.47,5.87-12.88,5.87A22.55,22.55,0,0,1,0,77.76a22.56,22.56,0,0,1,22.53-23c2.84,0,9.47,1,12.88,5.87V55.7H48.47V99.91H35.41Zm-10.7-6.62c5.4,0,10.7-3.89,10.7-10.51s-5.3-10.51-10.7-10.51S13.63,71.41,13.63,77.76,19.22,88.27,24.71,88.27Z" />
      <path d="M81.06,110.14c10,0,12.78-6.92,12.21-15.72-2.08,4.07-7.76,6.44-13.25,6.44C68.65,100.86,58,91.86,58,78,58,63.74,68.65,54.75,80,54.75c5.49,0,11.07,2.37,13.25,6.44V55.7h12.78V93.76c0,19-9.28,28.21-25,28.21a23.56,23.56,0,0,1-21.78-13.73c3.32-1.61,7.29-3.59,10.6-5.2C71.4,107.11,76.61,110.14,81.06,110.14Zm1.23-42.89a10.6,10.6,0,1,0,0,21.2A10.76,10.76,0,0,0,93,77.66C93,71,87.78,67.25,82.29,67.25Z" />
      <path d="M131.34,99.91H118.18V55.7h13.16v6.43a14.79,14.79,0,0,1,12.78-7.38c9.94,0,16.19,6.15,16.19,18.75V99.91H147.15V76.34c0-5.87-3.22-8.81-7.67-8.81-4.63,0-8.14,2.27-8.14,9Z" />
      <path d="M169.32,77.66c0-13.92,10.41-22.91,22.91-22.91s23,9,23,22.91-10.51,23-23,23S169.32,91.58,169.32,77.66Zm33,0a10,10,0,1,0-10,10.13A9.81,9.81,0,0,0,202.27,77.66Z" />
      <path d="M236.17,81.73c-13.25-3.59-13.35-10.32-13.25-14.39.09-6.53,8-12.59,17.23-12.59,8.81,0,18.08,3.88,18.18,14.68h-12.4c-.1-3.32-2.94-3.89-5-3.89-2.84,0-4.74,1.33-4.64,3.32.09,1.32,1.23,2.65,3.88,3.31l7.48,2c10.7,2.94,12,10,12,12.88,0,9.37-9.84,13.82-19.12,13.82-9,0-18.37-5.4-18.46-15.25h12.31c.09,2.56,2.93,5.12,6.53,5.12,2.93-.1,5.39-1.42,5.39-3.69,0-1.9-1.13-2.94-4.35-3.79Z" />
      <path d="M408.14,85.05A7.91,7.91,0,1,1,400,92.91,7.9,7.9,0,0,1,408.14,85.05Z" />
      <path d="M460.22,94.89c-2.84,4.26-9.47,5.87-12.87,5.87a22.55,22.55,0,0,1-22.54-23,22.56,22.56,0,0,1,22.54-23c2.84,0,9.46,1,12.87,5.87V55.7h13.07V99.91H460.22Zm-10.7-6.62c5.4,0,10.7-3.89,10.7-10.51s-5.3-10.51-10.7-10.51-11.07,4.16-11.07,10.51S444,88.27,449.52,88.27Z" />
      <path d="M492,31.65a7.72,7.72,0,1,1,0,15.43,8,8,0,0,1-8.23-7.76C483.72,35,487.5,31.65,492,31.65Zm6.54,68.26H485.42V55.7h13.07Z" />
      <path
        fill="var(--color-primary)"
        opacity="0.25"
        d="M323.1,0a8,8,0,0,1,8.23,7.86,8.19,8.19,0,0,1-16.37,0A7.9,7.9,0,0,1,323.1,0Z"
      />
      <path
        fill="var(--color-primary)"
        opacity="0.15"
        d="M286.83,7.91a8,8,0,0,1,8.23,7.85,8.19,8.19,0,0,1-16.37,0A7.9,7.9,0,0,1,286.83,7.91Z"
      />
      <path
        fill="var(--color-primary)"
        opacity="0.4"
        d="M357.47,6.92a8,8,0,0,1,8.23,7.86,8.19,8.19,0,0,1-16.37,0A7.91,7.91,0,0,1,357.47,6.92Z"
      />
      <path
        fill="var(--color-primary)"
        opacity="0.1"
        d="M259.61,27.8a7.91,7.91,0,1,1-8.15,7.86A8,8,0,0,1,259.61,27.8Z"
      />
      <path
        fill="var(--color-primary)"
        opacity="0.6"
        d="M385.32,26.49a7.91,7.91,0,1,1-8.15,7.86A8,8,0,0,1,385.32,26.49Z"
      />
      <path
        fill="var(--color-primary)"
        opacity="0.8"
        d="M401.69,53.61a7.91,7.91,0,1,1-8.14,7.86A7.91,7.91,0,0,1,401.69,53.61Z"
      />
    </g>

    {/* Override for currentColor when className specifies text color */}
    <style>{`.logo.fill-current g { fill: currentColor; }`}</style>
  </svg>
)
